/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Filter_ActivityInputs */

const vi_stocktake_filter_activity = /** @type {(inputs: Stocktake_Filter_ActivityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có biến động`)
};

/**

* @param {Stocktake_Filter_ActivityInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_filter_activity = /** @type {((inputs?: Stocktake_Filter_ActivityInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Filter_ActivityInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_filter_activity(inputs)
});